import { useTranslation } from 'react-i18next'

import { useUserData } from '../../../../hooks'
import { getUserFullName } from '../../../../utils/user'
import { Checkbox, CHECKBOX_SIZE, CHECKBOX_TYPE } from '../../../Checkbox'
import Text from '../../../Text'
import { CalendarRailBlock } from '../CalendarRailBlock'

import {
  QA_NAME_CALENDAR_RAIL_CURRENT_USER,
  QA_NAME_CALENDAR_RAIL_CURRENT_USER_NAME,
} from './CalendarRailWho.constants'

import * as styles from './CalendarRailWho.module.css'

function CalendarRailWho() {
  const { t } = useTranslation()

  const userData = useUserData()

  return (
    <CalendarRailBlock title={t('Calendar.RailWhoKey')}>
      <div className={styles.CalendarRailWho}>
        <Checkbox
          checked
          disabled
          qaName={QA_NAME_CALENDAR_RAIL_CURRENT_USER}
          size={CHECKBOX_SIZE.small}
          type={CHECKBOX_TYPE.action}
        />
        <Text qaName={QA_NAME_CALENDAR_RAIL_CURRENT_USER_NAME}>
          {t('Calendar.RailCurrentUserKey', {
            name: getUserFullName(userData),
          })}
        </Text>
      </div>
    </CalendarRailBlock>
  )
}

export default CalendarRailWho
